export default "__VITE_ASSET__CPHutqeN__"